import { Outlet, useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { useEffect, useState } from "react";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { AppBox, AppContainer, AppModal, NotFound } from "../../../commons/components";
import { setPageTitle } from "../../../redux/slices/page-title-slice";
import { cleanUpSeasonFixtureGroupFixtures } from "../../../redux/slices/football/admin/season/fixture-group/manage-fixture-group-fixtures-slice";
import { cleanUpSeasonFixtureGroups } from "../../../redux/slices/football/admin/season/fixture-group/manage-fixture-group-list-slice";
import { cleanUpCompetitionSeasonTeams } from "../../../redux/slices/football/admin/competition/manage-competition-season-teams-slice";
import setDocumentTitle from "../../../commons/utilities/document-title";
import { cleanUpManageStanding } from "../../../redux/slices/football/admin/competition/manage-competition-season-standing-slice";
import { cleanUpManageSeasonList } from "../../../redux/slices/football/admin/competition/manage-competition-season-slice";
import IconEdit from "../../../commons/components/icons/edit";
import { cleanUpManageSeasonKnockouts } from "../../../redux/slices/football/admin/season/knockout/manage-knockout-list-slice";
import { cleanUpSeasonTeamGroups } from "../../../redux/slices/football/admin/season/team-group/manage-team-group-list-slice";
import { cleanUpGlobalSeasonSelectedOption } from "../../../redux/slices/global-season-select-slice";
import { cleanUpStepperFormData } from "../../../redux/slices/stepper-form-slice";
import HostedTournamentManageDetailHeader from "./components/HostedTournamentManageDetailHeader";
import {
  cleanUpHostedCompetitionInfo,
  fetchManageHostedCompetition,
} from "../../../redux/slices/football/admin/team/hosted-competition/manage-team-hosted-competition-slice";
import { cleanUpFetchedCompetitionData } from "../../../redux/slices/football/fetched-competition-slice";
import TournamentAddEdit from "../tournaments/components/tournamentAddEdit/TournamentAddEdit";

export default function HostedTournamentDetailManage() {
  const { hostedCompetitionId, teamId } = useParams();
  const dispatch = useAppDispatch();
  const [isEditHostedTournament, setIsEditHostedTournament] = useState(false);
  const { hostedCompetitionInfo, hostedCompetitionInfoStatus } = useAppSelector(
    (state) => state.footballManageHostedCompetitionDetail
  );
  const { hostedCompetitionAddResponseStatus } = useAppSelector((state) => state.footballManageHostedCompetitionAdd);
  const { hostedCompetitionEditResponseStatus } = useAppSelector((state) => state.footballManageHostedCompetitionEdit);
  useEffect(() => {
    if (teamId && hostedCompetitionId) {
      dispatch(
        fetchManageHostedCompetition({ teamId: Number(teamId), hostedCompetitionId: Number(hostedCompetitionId) })
      );
    }
  }, [hostedCompetitionId, teamId]);

  useEffect(() => {
    if (hostedCompetitionInfoStatus === StatusEnum.Failed) {
      return () => {
        dispatch(cleanUpHostedCompetitionInfo());
      };
    }
  }, [hostedCompetitionInfoStatus]);

  useEffect(() => {
    setDocumentTitle([`${hostedCompetitionInfo.abbreviation}`, "Manage"]);
  }, [hostedCompetitionInfo]);

  const handleAfterEdit = () => {
    setIsEditHostedTournament(false);
    dispatch(
      fetchManageHostedCompetition({ teamId: Number(teamId), hostedCompetitionId: Number(hostedCompetitionId) })
    );
  };

  const handleAfterEditClose = () => {
    setIsEditHostedTournament(false);
    dispatch(cleanUpStepperFormData());
  };

  useEffect(() => {
    dispatch(setPageTitle(""));
    return () => {
      dispatch(cleanUpHostedCompetitionInfo());
      dispatch(cleanUpGlobalSeasonSelectedOption());
      dispatch(cleanUpSeasonFixtureGroupFixtures());
      dispatch(cleanUpSeasonFixtureGroups());
      dispatch(cleanUpCompetitionSeasonTeams());
      dispatch(cleanUpManageSeasonList());
      dispatch(cleanUpManageStanding());
      dispatch(cleanUpManageSeasonKnockouts());
      dispatch(cleanUpSeasonTeamGroups());
      dispatch(cleanUpFetchedCompetitionData());
    };
  }, []);

  return (
    <AppContainer>
      {hostedCompetitionInfoStatus === StatusEnum.Failed ? (
        <NotFound />
      ) : (
        <AppBox mt="md" flexDirection="column" gap="md">
          <HostedTournamentManageDetailHeader onEditTournament={() => setIsEditHostedTournament(true)} />
          <Outlet />
        </AppBox>
      )}
      <AppModal
        opened={isEditHostedTournament}
        modalSize="lg"
        onClose={handleAfterEditClose}
        title="Edit Tournament"
        titleIcon={<IconEdit />}
        withLoadingButton={
          hostedCompetitionAddResponseStatus === StatusEnum.Loading ||
          hostedCompetitionEditResponseStatus === StatusEnum.Loading
        }
        withoutButtons
      >
        <TournamentAddEdit
          hostTeam={hostedCompetitionInfo.hostTeam}
          competitionData={hostedCompetitionInfo}
          onSave={handleAfterEdit}
        />
      </AppModal>
    </AppContainer>
  );
}
